import * as Sentry from '@sentry/react';

export function logError(error: unknown) {
  Sentry.captureException(error);
}